import { Control, Controller } from 'react-hook-form'

import { SelectFilterRow, SelectFilterRowIProps } from './SelectFilterRow'

type SelectFilterFieldIProps<T> = Omit<
  SelectFilterRowIProps<T>,
  'value' | 'onChange'
> & {
  control: Control<any>
  name: string
}

/**
 * `react-hook-form`-connected SelectFilterRow: owns the `Controller` so a
 * drawer body can declare the field in one line instead of hand-writing the
 * render prop. Seeded/reset by the form's `defaultValues` (see
 * `./FilterDrawer`), so no per-field `defaultValue` is needed.
 */
export const SelectFilterField = <T,>({
  control,
  name,
  ...rowProps
}: SelectFilterFieldIProps<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ onChange, value }) => (
      <SelectFilterRow {...rowProps} onChange={onChange} value={value} />
    )}
  />
)
